import React from "react"
import { Link } from "gatsby"
import Post from "../../Home/components/Post"

import { IBlogPost } from "utils/types"

interface OtherPostsProps {
  previous: Pick<IBlogPost, "title" | "slug" | "image"> | null
  next: Pick<IBlogPost, "title" | "slug" | "image"> | null
}


export default function OtherPosts({ previous, next }: OtherPostsProps) {
  return (
      <div className="other-posts">
        <div className="post-previous">
            {previous && <Post post={previous} showDescription={false}/>}
        </div>

        <div className="post-next">
            {next && <Post post={next} showDescription={false}/>}
        </div>

          <div className="links">
          <Link to="/" className="">
            Back to home
          </Link>
        </div>

      </div>
  )
}
